// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
// import store from '../store'
import UniversalForm from '@/components/UniversalForm.vue'
// import PageExpensesBySubsidy from '@/components/pages/ExpensesBySubsidyPage.vue'
import MainPark from '@/components/pages/MainParkPage.vue'
import ErrorPage from '@/components/pages/ErrorPage.vue'
import PlicanteTables from '@/components/pages/plicanteTables.vue'
import RolesPage from '@/components/pages/RolesPage.vue'
const routes = [
    {
        path: '/',
        name: 'mainPark',
        component: MainPark
    },
    {
        path: '/form',
        name: 'UniversalForm',
        component: UniversalForm
    },
    {
        path: '/table/:id',
        name: 'plicanteTable',
        component: PlicanteTables
    },
    {
        path: '/roles',
        name: 'Roles',
        component: RolesPage
    },
    {
        path: '/error-page',
        name: 'ErrorPage',
        component: ErrorPage
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
 if (!to.matched?.length) {
    next({ name: 'ErrorPage' }) 
  }
  else {
    next()
  }
})

export default router
